import { render, staticRenderFns } from "./CardSuspend.vue?vue&type=template&id=05d2fc66"
import script from "./CardSuspend.vue?vue&type=script&lang=js"
export * from "./CardSuspend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports